<template>
  <b-modal
    id="modal-leaves-taken-list"
    ref="modal-leaves-taken-list"
    :title="`Leaves Taken - ${selectedLeaveTypeForList || 'All Types'}`"
    ok-title="Close"
    cancel-title=""
    size="lg"
    hide-footer
  >
    <div v-if="filteredLeavesForList.length > 0">
      <b-table
        :items="filteredLeavesForList"
        :fields="leavesTakenListFields"
        striped
        hover
        responsive
        class="mt-2"
      >
        <template #cell(employee_name)="data">
          {{ data.item.employee_name || data.item.emp_id || 'N/A' }}
        </template>
        <template #cell(from_date)="data">
          {{ formatDate(data.item.from_date) }}
        </template>
        <template #cell(to_date)="data">
          {{ formatDate(data.item.to_date) }}
        </template>
        <template #cell(leave_type)="data">
          {{ formatLeaveType(data.item.leave_type) }}
          <b-badge v-if="data.item.partial_wfh" variant="warning" class="ml-1" style="font-size:0.7rem;">Partial</b-badge>
        </template>
        <template #cell(total_days)="data">
          {{ parseFloat(data.item.total_days || 0).toFixed(1) }} {{ parseFloat(data.item.total_days || 0) === 1 ? 'day' : 'days' }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="getApprovalStatusVariant(data.item.status)">
            {{ formatApprovalStatus(data.item.status) }}
          </b-badge>
        </template>
      </b-table>
    </div>
    <div v-else class="text-center py-4">
      <p class="text-muted">No leaves found for this leave type.</p>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BTable, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'LeavesTakenListModal',
  components: {
    BModal, BTable, BBadge,
  },
  props: {
    filteredLeavesForList: { type: Array, default: () => [] },
    leavesTakenListFields: { type: Array, default: () => [] },
    selectedLeaveTypeForList: { type: String, default: null },
    formatDate: { type: Function, default: (d) => d },
    formatLeaveType: { type: Function, default: (t) => t },
    getApprovalStatusVariant: { type: Function, default: () => 'secondary' },
    formatApprovalStatus: { type: Function, default: (s) => s },
  },
}
</script>
